import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountInvoiceHistoryPage} from '../../../../../../features/one-time-credit/pages/InvoiceAccountInvoiceHistoryPage/InvoiceAccountInvoiceHistoryPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/one-time-credit/$accountId/invoice-history',
)({
  component: InvoiceAccountInvoiceHistoryPage,
  staticData: {crumbKey: 'navigation.invoices'},
});
